<template>
  <div :class="['col-xs-12', `col-md-${size}`]">
    <form-group-search-select
      ref="input"
      :label="label"
      :readonly="readonly"
      :value="value"
      :name="name"
      :options="periodosOption || []"
      :data-vv-as="label"
      :placeholder="placeholder"
      @input="atualizarPeriodo($event)"
      @change="atualizarPeriodo($event)"
      v-validate="{ required: required }"
    />
  </div>
</template>

<script>
import CursoService from "../../../../domain/corpore/CursoService";
import CampoEnum from "../../../../domain/protocolo/CampoEnum";
import SwalMessage from "../../../../domain/message/SwalMessage";

export default {
  name: "c-protocolo-periodo",
  $_veeValidate: {
    validator: "new"
  },
  inject: ["$validator", "formValues"],
  props: {
    label: String,
    id: String,
    name: {
      required: true,
      type: String
    },
    size: {
      type: String,
      default: "6"
    },
    disabled: Boolean,
    placeholder: String,
    readonly: Boolean,
    value: String,
    required: Boolean,
    login: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      campoEnum: CampoEnum,
      periodosOption: [
        {
          value: "1",
          text: `1° Período`
        },
        {
          value: "2",
          text: `2° Período`
        },
        {
          value: "3",
          text: `3° Período`
        },
        {
          value: "4",
          text: `4° Período`
        },
        {
          value: "5",
          text: `5° Período`
        },
        {
          value: "6",
          text: `6° Período`
        },
        {
          value: "7",
          text: `7° Período`
        },
        {
          value: "8",
          text: `8° Período`
        },
        {
          value: "9",
          text: `9° Período`
        },
        {
          value: "10",
          text: `10° Período`
        },
        {
          value: "11",
          text: `11° Período`
        },
        {
          value: "12",
          text: `12° Período`
        }
      ]
    };
  },
  computed: {
    usuario() {
      return this.$store.state.usuario;
    }
  },
  mounted() {
    this.$el.value = this.value;
  },
  asyncComputed: {
    periodos() {
      let curso = this.formValues.cursoId;
      if (curso) {
        let login = this.login != "" ? this.login : this.usuario.login;
        const cursoService = new CursoService(this.$http);
        return cursoService
          .getPeriodosAtivosByCurso(curso, login)
          .then(result => {
            if (result.periodo) {
              return [
                {
                  value: result.periodo.toString(),
                  text: `${result.periodo}° Período`
                }
              ];
            }
          })
          .catch(err => {
            SwalMessage.warningMessage(`<p>${err.message}</p>`, "Ops!");
          });
      }
    }
  },
  methods: {
    atualizarPeriodo(value) {
      this.formValues.periodoId = value;
      this.$emit("input", value);
    }
  },
  watch: {
    periodos(value) {
      if (value && value.length == 1) {
        this.atualizarPeriodo(value[0].value.toString());
      }
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/components/UIComponents/Protocolo/Campos/Periodo.vue